<template>
  <input
    type="checkbox"
    class="review-selection-cell"
    :checked="checked"
    :disabled="disabled"
    :aria-label="label"
    :data-testid="testId"
    @change="handleToggle"
  />
</template>

<script setup>
/**
 * Per-row inclusion checkbox content for a review table's selection column.
 * Renders the bare checkbox — the owning table supplies the <td>.
 */
defineProps({
  /** Whether the row is currently included in the confirm action. */
  checked: {
    type: Boolean,
    default: false,
  },
  /** Accessible name; the caller interpolates the row name into it. */
  label: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  /**
   * data-testid from the caller's flow catalog. Shared component: never
   * hardcoded here.
   */
  testId: {
    type: String,
    default: undefined,
  },
});

const emit = defineEmits(["toggle"]);

function handleToggle() {
  emit("toggle");
}
</script>

<style scoped lang="scss">
.review-selection-cell {
  cursor: pointer;
  margin: 0;
  vertical-align: middle;
  accent-color: var(--sp-sys-color-primary);

  &:disabled {
    cursor: not-allowed;
  }
}
</style>
